import { render } from "./Index.vue?vue&type=template&id=17361036&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-17361036"

export default script